export default __webpack_public_path__ + "static/media/admission.2744b067.png";